export const QUERY_OPTIONS_TYPE_EDITOR = 'EDITOR'
export const QUERY_OPTIONS_TYPE_SIDEBAR = 'SIDEBAR'

export const QUERY_OPTIONS = {
  [QUERY_OPTIONS_TYPE_EDITOR]: '',
  [QUERY_OPTIONS_TYPE_SIDEBAR]: 'count=100&skip=0&sort=name&type=images',
}
